module.exports = __webpack_public_path__ + "static/img/pedline-logo.06e0535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pedline-logo.png
// module id = q8JC
// module chunks = 1